import React,{ useEffect,useState } from 'react';
import Panel from "../../Panel";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {connect} from "react-redux";
import ModelCronJobs from '../../../../Models/CronJobs/CronJobs';
import ModelCronJob from '../../../../Models/CronJobs/CronJob';
import {Link, useHistory} from "react-router-dom";
import {faExternalLinkAlt, faEye, faHotel, faPen, faPlay} from "@fortawesome/free-solid-svg-icons";
import Tooltip from "rc-tooltip";
import DataTable from "../../DataTable";

const WPSitesTable = ({ dispatch, title, limit}) => {

    const [isTableLoaded,setLoaded] = useState(false);
    const [submission,setSelectedSubmission] = useState(null);
    const cjsm = new ModelCronJobs();
    const cjm = new ModelCronJob();
    const history = useHistory();

    const redirect = (link) =>{
        history.push(link);
    };

    const columns =[
        {
            width: 300,
            Header: "Edit",
            Cell: ({ cell }) => {
                 // debugger
                return (
                    <>
                        <Tooltip placement="top" overlay={"View/Edit"}>
                            <button className={ "btn btn-info btn-sm m-0 mr-2 mt-1 pt-1 pb-1 pl-2 pr-1"} onClick={() => redirect("/cj/"+cell.row.original.cj_id)}>
                                <FontAwesomeIcon icon={faEye}/>
                            </button>
                        </Tooltip>
                        <Tooltip placement="top" overlay={"View in New Tab"}>
                            <Link
                                to={"/cj/" + cell.row.original.cj_id}
                                target="_blank"
                            >
                                <button type={"button"} className={ "btn btn-info btn-sm m-0 mr-2 mt-1 pt-1 pb-1 pl-2 pr-1"}>
                                    <FontAwesomeIcon icon={faExternalLinkAlt} />
                                </button>
                            </Link>
                        </Tooltip>
                    </>
                )
            }
        },{
            width: 300,
            Header: "Name",
            accessor: "wps_name"
        },{
            Header: 'ID',
            accessor: 'wps_id',
            width: 100
        },{
            Header: 'Sitename',
            accessor: 'wps_sitename',
            width: 150
        },{
            Header: 'URL',
            accessor: 'wps_url'
        },{
            Header: 'Username',
            accessor: 'wps_username'
        },{
            Header: 'Max Daily Articles',
            accessor: 'wps_max_daily_articles'
        }
    ];

    const tableStructure= {
        tableHeaderData: columns
    };

    return (

        <Panel xl={12} lg={12} md={12} title={title??"Submissions"} subhead="Table of WP Sites">
            <div>
                <DataTable columns={columns} endpoint={"/wps/getWPSites"}/>
            </div>
        </Panel>

    );
};

export default connect(state => ({
}))(WPSitesTable);
